import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { appService } from '../../_services';
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { authHeader, config } from '../../_helpers'
import { de } from 'date-fns/locale';

export class MakePayment extends Component {
    displayName = MakePayment.name

    constructor(props) {
        super(props);
        this.state = {
            url: ''
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handlebtnClick = this.handlebtnClick.bind(this);
    }

    componentDidMount() {
        var self = this;
         
        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify(this.props.YourDetails),
            //cache: 'no-cache',
        };

        fetch(config.apiUrl + '/Cart/MakePayment', requestOptions)
            .then(this.handleResponse, this.handleError)
            .then(function (response) {
                self.setState({ url: response.url });

            }); 

    }


    handleResponse(response) {
        return new Promise((resolve, reject) => {
            if (response.ok) {
                // return json if it was returned in the response
                var contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    response.json().then(json => resolve(json));
                } else {
                    resolve();
                }
            } else {
                // return error message from response body
                response.text().then(text => reject(text));
            }
        });
    }

    handleError(error) {
        return Promise.reject(error && error.message);
    }

    handleSelect(Activekey) {
        document.getElementById('controlled-tab-example-tab-3').click();
    }

    handlebtnClick(event) {


        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify(this.props.YourDetails),
        };
        var self = this;
        var hdnvalue = document.getElementById('hdncardpayments').value;
         
        fetch(config.apiUrl + '/Cart/MoveProductFromCartToOrder?BatchId=' + hdnvalue, requestOptions).then(this.handleResponse, this.handleError)
            .then(function (response) {
                
                self.setState({ url: response.url });

            });
         
    }
    
    render() {
        
        return (
            
            <div className="col-12 klo-shopping-cart">
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">

                        <div id="yourDetails" className="mt-4 font-500">
                            <p className="franziskafont">Payment details</p>
                            <div className="row">
                                <div className="col mr-4">
                                    <form>
                                        <input type="hidden" name="hdncardpayments" id="hdncardpayments" />
                                        <iframe src={this.state.url} id="ipayframe" width="100%" height="450px" frameBorder="0"></iframe>
                                        <button type="button" style={{ 'display': 'none' }} name="hdnBtn" id="hdnBtn" onClick={this.handlebtnClick}></button>
                                    </form>
                                </div>

                            </div>
                            <hr className="mt-4 mb-3" /><br></br>
                            <div className="row mb-5 mt-3 ">
                                <div className="col">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <button type="button" onClick={() => this.handleSelect("3")} className="btn float-left back-btn rounded-0">Back</button>
                                        </div>
                                        {/*   <div className="col-sm-3">
                                                <button type="button" className="btn btn-info next rounded-0">Pay by secure server   </button>
                                            </div>
                                            */}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> </div> </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Shopping Cart/MakePayment.jsx